import { isFunction } from 'lodash';

export const isInputElement = (element: Element | null): element is HTMLInputElement | HTMLTextAreaElement => {
    if (!element) return false;

    return element.tagName === 'INPUT' || element.tagName === 'TEXTAREA';
};

/**
 * Returns whether an element is contained in a control that can receive text or selection focus.
 */
export const isEditableElement = (element: Element | null): boolean =>
    !!element?.closest('input, textarea, select, [contenteditable="true"]');

/**
 * Blur the currently focused text input so the virtual keyboard can dismiss.
 */
export const blurActiveTextInput = (): void => {
    const activeElement = document.activeElement;

    if (!isInputElement(activeElement) || !isFunction(activeElement.blur)) return;

    activeElement.blur();
};
